import { z } from 'zod';

/** Rejects NaN and ±Infinity, which JSON would otherwise silently turn into null. */
export const finite = z.number().refine(Number.isFinite, { message: 'Zahl muss endlich sein' });
export const positive = finite.refine((v) => v > 0, { message: 'Wert muss größer als 0 sein' });
export const nonNegative = finite.refine((v) => v >= 0, {
  message: 'Wert darf nicht negativ sein',
});

export const idSchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[A-Za-z0-9_-]+$/, 'Ungültige ID');

export const colorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Farbe als #RRGGBB');

export const vec2Schema = z.object({ x: finite, y: finite });
export const vec3Schema = z.object({ x: finite, y: finite, z: finite });

/** At least three vertices; simplicity is checked at document level for clearer errors. */
export const polygonSchema = z.array(vec2Schema).min(3).max(512);

export const dimensionsSchema = z.object({
  width: positive,
  depth: positive,
  height: positive,
});

export const transformSchema = z.object({
  position: vec3Schema,
  /** Counter-clockwise rotation around the vertical axis, radians. */
  rotation: finite,
});
